/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlaylistAddedTimestamp
 */
export interface PlaylistAddedTimestamp {
    /**
     * 
     * @type {number}
     * @memberof PlaylistAddedTimestamp
     */
    metadataTimestamp: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistAddedTimestamp
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof PlaylistAddedTimestamp
     */
    trackId: string;
}

/**
 * Check if a given object implements the PlaylistAddedTimestamp interface.
 */
export function instanceOfPlaylistAddedTimestamp(value: object): value is PlaylistAddedTimestamp {
    let isInstance = true;
    isInstance = isInstance && "metadataTimestamp" in value && value["metadataTimestamp"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "trackId" in value && value["trackId"] !== undefined;

    return isInstance;
}

export function PlaylistAddedTimestampFromJSON(json: any): PlaylistAddedTimestamp {
    return PlaylistAddedTimestampFromJSONTyped(json, false);
}

export function PlaylistAddedTimestampFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistAddedTimestamp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metadataTimestamp': json['metadata_timestamp'],
        'timestamp': json['timestamp'],
        'trackId': json['track_id'],
    };
}

export function PlaylistAddedTimestampToJSON(value?: PlaylistAddedTimestamp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metadata_timestamp': value.metadataTimestamp,
        'timestamp': value.timestamp,
        'track_id': value.trackId,
    };
}

